import * as Yup from 'yup';

export const dashboardPluviometro = {
    initialValues: {
        dataInicial: '',
        dataFinal: '',
        estacaoMeteorologica: null
    },
    validation: Yup.object().shape({
        dataInicial: Yup.string().required('Campo obrigatório'),
        dataFinal: Yup.string().required('Campo obrigatório'),
    })
}
